import Department from './components/department'
let _self
export const regulation = {
    components: {
        Department
    },
    data() {
        return {
            show: true,
            date: '',
            form: {
                radio: 1,
                number: '',
                fix_app_notice: 2,
                fix_mailbox: '',
                free_app_notice: 2,
                free_mail_notice: 2,
                leader_option1: '',
                staff_option1: '',
                leader_option2: '',
                staff_option2: ''
            },
            form2: {
             radio: 0,
             text: ''
            },
            rules: {
                radio: [{ required: true, message: '请选择删除时间！', trigger: 'blur' }],
                number: [{ required: true, message: '请输入删除客户数量', trigger: 'blur' }, { pattern: /^[1-9|^\\.]/, message: '删除客户数量不能为0和负数' }]
                // text: [{ required: true, message: '请输入字段名称', trigger: 'blur' }]
            },
            startDate: '',
            endDate: '',
            sendName: [],
            sendOutName: [],
            disabled: true,
            showInput: false, // 控制输入框显示的变量
            isDepartmentDialog: false,
            g: [],
            q: [],
            x: [],
            k: '',
            h: '',
            send: [],
            m: [],
            kdsa: [],
            checkedEmployees: [],
            tipsRadio: '固定通知人',
            isStaffDialog: false,
            noticeStaff: [],
            checkedStaffs: [],
            leaderOptions: {
              1: [{ value: '直属上级', label: '直属上级' }],
              2: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '别名', label: '别名' }]
            },
            staffOptions: {
              1: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '别名', label: '别名' }],
              2: [{ value: '主体名称', label: '主体名称' }, { value: '邮箱', label: '邮箱' }, { value: '手机号', label: '手机号' }, { value: '工号', label: '工号' }]
            }
        }
    },
    watch: {
        sendName: function(newVal, oldVal) {
        },
        sendOutName: function(newVal, oldVal) {
        }
    },
    mounted() {
        _self = this
        this.startDate = this.$moment().subtract(-1, 'day').format('YYYY-MM-DD 00:00:00')
        this.endDate = this.$moment().subtract(-1, 'day').format('YYYY-MM-DD 23:59:59')
        this.getTime()
        this.getFixNotice()
        this.getDetail()
        this.getRegulaOption()
    },
    methods: {
        getRegulaOption() {
          this.$api.post('/api/system/regulaoption/list').then(res => {
             if (res) {
              if (res.leaderOptions) _self.leaderOptions = res.leaderOptions
              if (res.staffOptions) _self.staffOptions = res.staffOptions
             }
          })
        },
        getFixNotice () {
           this.$api.post('/api/system/fixnotice/list').then(res => {
              // this.form.fix_app_notice = [{ id: 'FanJiaBei', name: '范佳贝' }]
              // console.log(this.form.fix_app_notice)

              this.checkedStaffs = res
              this.noticeStaff = res
           })
        },

        getDetail() {
            this.$api.post('/api/system/sensitive/rule/list').then(res => {
                this.checkedEmployees = res.staff
                // var noticeList = JSON.parse(res.disable_rule.fix_notice_list)
                // this.checkedStaffs = noticeList
                // this.noticeStaff = noticeList
                this.form.fix_app_notice = res.disable_rule.fix_app_notice
                this.form.fix_mailbox = res.disable_rule.fix_mailbox
                this.form.free_app_notice = res.disable_rule.free_app_notice
                this.form.free_mail_notice = res.disable_rule.free_mail_notice
                this.form.leader_option1 = res.disable_rule.leader_option1
                this.form.staff_option1 = res.disable_rule.staff_option1
                this.form.leader_option2 = res.disable_rule.leader_option2
                this.form.staff_option2 = res.disable_rule.staff_option2
                this.q = res.staff
                this.sendName = this.q
                this.sendName.forEach(k => {
                    this.g.push(k.id)
                })
                this.k = res.disable_rule.user_number
                this.form.number = this.k
                if (res.disable_rule.delete_time === 1) {
                    this.h = 1
                    this.form.radio = this.h
                } else if (res.disable_rule.delete_time === 2) {
                    this.h = 2
                    this.form.radio = this.h
                } else if (res.disable_rule.delete_time === 3) {
                    this.h = 3
                    this.form.radio = this.h
                }
              this.form2.text = res.disable_rule.is_custom_direct_leader
              if (res.disable_rule.is_direct_leader === 2) {
                this.form2.radio = 1
              } else if (res.disable_rule.is_direct_leader === 3) {
                this.showInput = true
                this.form2.radio = 2
              }
            })
        },
        asdji() {
            this.$router.go(-1)
        },
        async checkUser(checkedEmployee) {
            const c = []
            if (checkedEmployee.length === 0) {
                this.isDepartmentDialog = false
                this.sendOutName = this.g
                this.getDetail()
                return false
            } else {
                const res = await this.$api.post('/api/system/sensitive/rule/list', {
                    if (res) {
                        return res.staff
                    }
                })
                const h = res.staff
                if (checkedEmployee && checkedEmployee.length > 0) {
                    const newArr = []
                    for (let i = 1; i < checkedEmployee.length; i++) {
                        let repeat = false
                        for (let j = 0; j < h.length; j++) {
                            if (checkedEmployee[i].user_id === h[j].user_id) {
                                repeat = true
                                break
                            } else {
                            }
                        }
                        if (!repeat) {
                            newArr.push(checkedEmployee[i])
                        }
                    }
                    checkedEmployee.forEach(k => {
                        c.push(k.id)
                    })
                    if (checkedEmployee.length < h.length) {
                        this.sendName = checkedEmployee
                    } else {
                        this.sendName = h.concat(newArr)
                    }
                    this.send = c
                    this.isDepartmentDialog = false
                } else {
                    this.isDepartmentDialog = false
                }
            }
        },
        showStaffDialog() { this.isStaffDialog = true },
        async checkStaff(checkedStaff) {
          this.noticeStaff = checkedStaff
          this.isStaffDialog = false
        },
        redact() {
            this.disabled = false
            this.show = false
        },
        getTime() {
            if (this.form.radio === 2) {
                this.startDate = this.$moment().subtract(-1, 'day').format('YYYY-MM-DD 00:00:00')
                this.endDate = this.$moment().subtract(-3, 'day').format('YYYY-MM-DD 23:59:59')
            } else if (this.form.radio === 3) {
                this.startDate = this.$moment().subtract(-1, 'day').format('YYYY-MM-DD 00:00:00')
                this.endDate = this.$moment().subtract(-7, 'day').format('YYYY-MM-DD 23:59:59')
            }
        },
      handleRadioChange(value) {
        this.showInput = value === 2
      },
        getData() {
            this.isDepartmentDialog = true
        },
        redact01(form) {
            this.$refs[form].validate(valid => {
                if (valid) {
                    this.sendOutName = []
                    this.m = []
                    this.k = []
                    this.sendName.forEach(k => {
                        this.m.push(k.id)
                    })
                    this.kdsa = this.m.concat(this.send)
                    for (var i = 0; i < this.kdsa.length; i++) {
                        if (this.sendOutName.indexOf(this.kdsa[i]) === -1) {
                            this.sendOutName.push(this.kdsa[i])
                        }
                    }
                    this.show = true
                    this.disabled = true
                    this.$api.post('/api/system/sensitive/add/rule', {
                    delete_time: this.form.radio,
                    user_number: this.form.number,
                    // is_direct_leader: this.form2.radio,
                    is_direct_leader: 2,
                    is_custom_direct_leader: this.form2.text,
                    content: this.sendOutName,
                    // fix_app_notice: this.form.fix_app_notice,
                    fix_app_notice: 1,
                    fix_mailbox: this.form.fix_mailbox,
                    free_app_notice: this.form.free_app_notice,
                    free_mail_notice: this.form.free_mail_notice,
                    leader_option1: this.form.leader_option1,
                    staff_option1: this.form.staff_option1,
                    leader_option2: this.form.leader_option2,
                    staff_option2: this.form.staff_option2
                    // fix_notice_list: this.checkedStaffs
                    }).then(res => {
                        this.getDetail()
                        this.$router.go(0)
                        // this.$router.replace({ path: '/control/operationLog' })
                    })
                }
            })
        },
        setAppNotice() {},
        tipsRadioChange(val) {},
        redact02() {
            this.show = true
            this.disabled = true
            this.sendName = this.q
            this.form.number = this.k
            this.radio = this.h
            this.$router.go(0)
        },
        close(item) {
            this.sendName.splice(this.sendName.indexOf(item), 1)
        }
    }
}
